import { render, staticRenderFns } from "./KusHomePublicInfo.vue?vue&type=template&id=8f2dcc14"
import script from "./KusHomePublicInfo.vue?vue&type=script&lang=js"
export * from "./KusHomePublicInfo.vue?vue&type=script&lang=js"
import style0 from "./KusHomePublicInfo.vue?vue&type=style&index=0&id=8f2dcc14&prod&lang=sass"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports